<template>
  <div v-if="contentBlock" :id="id" :class="contentBlockClass">
    <h3 class="title">
      <a @click.prevent="toggle">
        <i class="af-icons af-icons-info"></i>
        {{ contentBlock.title }} <i :class="chevronClass"></i>
      </a>
    </h3>
    <div class="body text-content" v-html="contentBlock.content" />
  </div>
</template>

<script>
import Storage from '@/lib/storage.js';
import storedVisibilityMixin, { Visibility } from '@/lib/components/Shared/mixins/stored-visibility-mixin.js';

export default {
  mixins: [storedVisibilityMixin],
  props: {
    contentBlock: {
      type: Object,
      default: null
    },
    modelName: {
      type: String,
      default: null
    },
    modelId: {
      type: Number,
      default: null
    }
  },
  computed: {
    id() {
      return `info-box-${this.contentBlock.id}-${this.modelId}`;
    },
    contentBlockClass() {
      return [
        'entry-content-block',
        'info-box',
        this.isOpen ? Visibility.OPEN : Visibility.CLOSED
      ];
    }
  },
  created() {
    if (this.contentBlock) {
      if (this.setInitialVisibility()) {
        return;
      }

      switch (this.contentBlock.visibility) {
        case Visibility.OPEN:
          this.isOpen = true;
          break;
        case Visibility.CLOSED:
          this.isOpen = false;
          break;
        default:
          // Open initially, then closed
          this.isOpen = true;
          this.storage.set(this.id, Visibility.CLOSED);
          break;
      }
    }
  }
};
</script>
